<div class="collection-card">
  <div class="collection-header">
    <div class="collection-title-section">
      <h2 class="collection-name">Collection {{ collectionNumber }} ( {{ collection.name }} )</h2>
    </div>
    <button class="expand-button" (click)="onToggleExpansion()" [attr.aria-expanded]="collection.isExpanded"
      [attr.aria-label]="collection.isExpanded ? 'Collapse collection' : 'Expand collection'">
      <img src="assets/icons/card-dropdown-icon.svg" alt="Toggle" class="dropdown-icon"
        [class.rotated]="collection.isExpanded">
    </button>
  </div>

  <div class="collection-metadata" *ngIf="collection.isExpanded">
    <div class="metadata-item">
      <div class="header">
        <span class="metadata-label">Created</span>
      </div>
      <span class="metadata-value" [title]="formatDate(collection.metadata.createdAt)">{{ formatDate(collection.metadata.createdAt) }}</span>
    </div>

    <div class="metadata-item">
      <div class="header">
        <span class="metadata-label">Model</span>
      </div>
      <span class="metadata-value" [title]="collection.metadata.generativeModel">{{ collection.metadata.generativeModel }}</span>
    </div>

    <div class="metadata-item">
      <div class="header">
        <span class="metadata-label">Embedding</span>
      </div>
      <span class="metadata-value" [title]="collection.metadata.embeddingType">{{ collection.metadata.embeddingType }}</span>
    </div>

    <div class="metadata-item">
      <div class="header">
        <span class="metadata-label">Last modified</span>
      </div>
      <span class="metadata-value" [title]="formatDateTime(collection.metadata.lastAccessedAt)">{{ formatDateTime(collection.metadata.lastAccessedAt) }}</span>
    </div>

    <div class="metadata-item">
      <div class="header">
        <span class="metadata-label">Create By</span>
      </div>
      <span class="metadata-value" [title]="collection.createdby">{{ collection.createdby }}</span>
    </div>
  </div>

  <div class="documents-section" *ngIf="collection.isExpanded">
    <div class="documents-header">
      <div class="toggle-container">
        <button class="toggle-btn" [class.active]="selected === 'documents'" (click)="setActive('documents')">
          <img src="assets/icons/document-icon.svg" alt="Documents" class="toggle-icon">
          Documents
        </button>
        <button class="toggle-btn" [class.active]="selected === 'texts'" (click)="setActive('texts')">
          <img src="assets/icons/texts.svg" alt="Texts" class="toggle-icon">
          Texts
        </button>
      </div>

      <div class="upload-container">
        <button class="add-document-btn" (click)="onAddDocument()" [disabled]="isBatchUploading">
          {{ isBatchUploading ? ('Uploading (' + activeUploadCount + ')') : 'Add to Collection' }}
          <img src="assets/icons/arrow.svg" alt="Upload" class="upload-icon">
        </button>
        <div class="upload-queue-indicator" *ngIf="isBatchUploading">
          Uploading documents to knowledge base...
        </div>
        <app-upload-dropdown *ngIf="showUploadDropdown" (optionSelected)="onUploadOptionSelected($event)">
        </app-upload-dropdown>
      </div>
    </div>

    <div class="documents-table" role="table" *ngIf="selected ==='documents'" aria-label="Documents">
      <div class="table-header" role="row">
        <div role="columnheader">Category</div>
        <div role="columnheader">Document Name</div>
        
        <div role="columnheader">Base File</div>
        <div role="columnheader">Added by</div>
        <div role="columnheader">Added on</div>
        <div role="columnheader">Size</div>
        <div role="columnheader">Actions</div>
      </div>

      <div class="table-row" role="row" *ngFor="let document of collection.documents; trackBy: trackByDocumentId">
        <div class="td-category" role="cell" [title]="getDocumentCategory(document)">{{ getDocumentCategory(document) }}</div>
        <div class="td-document-name" role="cell">
          <span class="document-name" [title]="getDisplayDocumentName(document)">{{ getDisplayDocumentName(document) }}</span>
          <div class="status-container">
            <span class="status-badge" *ngIf="document.isActiveDocument">Active</span>
            <div class="uploading-status" *ngIf="document.status === 'uploading'">
              <span class="uploading-text">Creating knowledge base...</span>
              <div class="progress-bar">
                <div class="progress-fill infinite"></div>
              </div>
            </div>
            <div class="uploading-status completed" *ngIf="document.status === 'completed'">
              <span class="completed-text">Completed</span>
            </div>
            <div class="failed-status" *ngIf="document.status === 'failed'">
              <span class="failed-badge">
                Upload Failed
                <img src="assets/icons/del-info-icon.svg" alt="Warning" class="warning-icon">
              </span>
            </div>
          </div>
        </div>
        <div class="td-base-file" role="cell" [title]="document.baseName || document.name">{{ document.baseName || document.name }}</div>
        <div class="td-added-by" role="cell" [title]="document.createdByName || collection.createdby">{{ document.createdByName || collection.createdby }}</div>
        <div class="td-added-on" role="cell" [title]="document.uploadedAt | date:'MMM d, y hh:mm a'">{{ document.uploadedAt | date:'MMM d, y hh:mm a' }}</div>
        <div class="td-size" role="cell" [title]="document.size">{{ document.size }}</div>
        <div class="td-actions" role="cell">
          <button class="action-btn view-btn" (click)="onViewDocument(document)"
            [attr.aria-label]="'View ' + document.name">
            <img src="assets/icons/show-eye.svg" alt="View" class="view-icon">
          </button>
          <button class="action-btn download-btn" (click)="onDownloadDocument(document)"
            [attr.aria-label]="'Download ' + document.name">
            <img src="assets/icons/download-button.svg" alt="Download" class="download-icon">
          </button>
          <button class="action-btn delete-btn" (click)="onDeleteDocument(document)"
            [disabled]="isDeletingDocument(document)"
            [class.is-deleting]="isDeletingDocument(document)"
            [attr.aria-label]="isDeletingDocument(document) ? ('Deleting ' + document.name) : ('Delete ' + document.name)">
            <span class="deleting-text" *ngIf="isDeletingDocument(document)">Deleting...</span>
            <img *ngIf="!isDeletingDocument(document)" src="assets/icons/bin-icon.svg" alt="Delete" class="download-icon">
          </button>
        </div>
      </div>
    </div>

    <div class="texts-container" *ngIf="selected ==='texts'">
      <div class="texts-table" role="table" aria-label="Texts">
        <div class="texts-header" role="row">
          <div class="th-heading" role="columnheader">Heading</div>
          <div class="th-text" role="columnheader">Text</div>
          <div class="th-Addedby" role="columnheader">Added by</div>
          <div class="th-uploaded" role="columnheader">Added on</div>
          <div class="th-actions" role="columnheader">Actions</div>
        </div>

        <div class="texts-row" role="row" *ngFor="let t of collection.texts || []" (mouseleave)="hoveredTextId = null">
          <div class="td-heading" role="cell">{{ t.heading }}</div>
          <div class="td-text" role="cell">
            <span class="ellipsis" (mouseenter)="hoveredTextId = t.id">{{ t.text }}</span>
            <div class="popover" >
              {{ t.text }}
            </div>
          </div>
          <div class="td-Addedby" role="cell">{{ t.createdByName }}</div>
          <div class="td-uploaded" role="cell">{{ t.uploadedAt | date:'MMM d, y' }}</div>
          <div class="td-actions" role="cell">
            <button class="action-btn delete-btn" (click)="onEditText(t)" [attr.aria-label]="'Edit ' + t.heading">
              <img src="assets/icons/edit-icon.svg" alt="Edit" class="download-icon">
            </button>
            <button class="action-btn delete-btn" (click)="onDeleteText(t)" [attr.aria-label]="'Delete ' + t.heading">
              <img src="assets/icons/bin-icon.svg" alt="Delete" class="download-icon">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>